import { queryOptions, useQuery } from "@tanstack/react-query";
import { getGoldRates } from "@/lib/gold-prices.functions";
import { getSilverRates } from "@/lib/silver-prices.functions";

export type LiveRates = {
  spotUsdPerOz: number;
  pkrPerUsd: number;
  inrPerUsd: number;
  fetchedAt: string;
};

const FALLBACK_FETCHED_AT = "2026-06-21T00:00:00.000Z";

export const FALLBACK_GOLD_RATES: LiveRates = {
  spotUsdPerOz: 4156,
  pkrPerUsd: 278,
  inrPerUsd: 83.5,
  fetchedAt: FALLBACK_FETCHED_AT,
};

export const FALLBACK_SILVER_RATES: LiveRates = {
  spotUsdPerOz: 65,
  pkrPerUsd: 278,
  inrPerUsd: 83.5,
  fetchedAt: FALLBACK_FETCHED_AT,
};

const THIRTY_MIN_MS = 30 * 60 * 1000;

export const goldRatesQueryOptions = queryOptions({
  queryKey: ["gold-rates"],
  queryFn: () => getGoldRates(),
  staleTime: THIRTY_MIN_MS,
});

export const silverRatesQueryOptions = queryOptions({
  queryKey: ["silver-rates"],
  queryFn: () => getSilverRates(),
  staleTime: THIRTY_MIN_MS,
});

const isBrowser = typeof window !== "undefined";

export function useGoldRates() {
  return useQuery({
    ...goldRatesQueryOptions,
    enabled: isBrowser,
    initialData: FALLBACK_GOLD_RATES,
    initialDataUpdatedAt: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchInterval: THIRTY_MIN_MS,
    refetchIntervalInBackground: false,
  });
}

export function useSilverRates() {
  return useQuery({
    ...silverRatesQueryOptions,
    enabled: isBrowser,
    initialData: FALLBACK_SILVER_RATES,
    initialDataUpdatedAt: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchInterval: THIRTY_MIN_MS,
    refetchIntervalInBackground: false,
  });
}